import React from 'react';

// Ortak onay modalı — tarayıcının window.confirm kutusu yerine kullanılır.
const ConfirmModal = ({ open, title = 'Onay', message, confirmText = 'Evet', cancelText = 'Vazgeç', onConfirm, onCancel, danger = false }) => {
    if (!open) return null;
    return (
        <div
            onClick={onCancel}
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 3000 }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{ background: 'var(--card-bg, #2d2d2d)', color: 'var(--text-color, #fff)', padding: '28px', borderRadius: '10px', width: '90%', maxWidth: '420px', boxShadow: '0 10px 40px rgba(0,0,0,0.5)', textAlign: 'center' }}
            >
                <h3 style={{ marginTop: 0, marginBottom: '12px' }}>{title}</h3>
                <p style={{ marginBottom: '24px', lineHeight: 1.5, fontSize: '1.05em' }}>{message}</p>
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    <button
                        onClick={onCancel}
                        style={{ padding: '10px 24px', borderRadius: '6px', border: 'none', cursor: 'pointer', background: '#6c757d', color: '#fff', fontWeight: 'bold', fontSize: '1em' }}
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        autoFocus
                        style={{ padding: '10px 24px', borderRadius: '6px', border: 'none', cursor: 'pointer', background: danger ? '#dc3545' : '#28a745', color: '#fff', fontWeight: 'bold', fontSize: '1em' }}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
